import { generatedApi } from './api.generated';
import { createEndpointExports, createHookExports, provideListTags } from '@skynet/data-helpers';
import type { HookExports } from '@skynet/data-helpers';
import { TELEGRAM_USERS_API_ENDPOINTS as cfg } from './config';

/**
 * A single read-only query. The `add`/`remove` rosters share one
 * `TelegramUsers` list tag regardless of `mode`/`domain` — every mutation
 * that could change either answer (`add-members`/`remove-members`/…) lives in
 * `@skynet/data-trading-groups` instead, so this package carries no
 * `invalidatesTags` of its own. The dashboard's `ws-assistant-effects`
 * invalidates this tag once such a job settles, alongside the
 * `TelegramGroups` invalidation it already does for the same event.
 */
export const telegramUsersApi = generatedApi.enhanceEndpoints({
  addTagTypes: ['TelegramUsers'],
  endpoints: {
    [cfg.listTelegramUsers.generated]: {
      providesTags: (result) => provideListTags(result, 'TelegramUsers'),
    },
  },
});

export const hookExports: HookExports<typeof cfg, typeof telegramUsersApi> = createHookExports(
  cfg,
  telegramUsersApi,
);

export const telegramUsersApiEndpoints = createEndpointExports(cfg, telegramUsersApi);
